import { Injectable } from '@angular/core';
import { BaseAPI } from '@core/services/base-api.service';
import { Mapper } from '@core/services/base-mapper.service';
import { APIConstants } from '@shared/constants';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserType } from '../enums/shared-enums.enum';
import { Role } from '@features/auth/models/role.model';

@Injectable({
  providedIn: 'root',
})
export class RoleAPI {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  getActiveRoles(userType: UserType = UserType.CUSTOMER): Observable<Role[]> {
    return this.baseAPI.get(`${APIConstants.API_GET_ACTIVE_ROLES}?userType=${userType}`).pipe(
      map((res) => {
        return this.mapper.fromJson(Role, res.data);
      })
    );
  }
}
